import { render, staticRenderFns } from "./InsCmsCat12.vue?vue&type=template&id=74b19bb1&scoped=true&"
import script from "./InsCmsCat12.vue?vue&type=script&lang=ts&"
export * from "./InsCmsCat12.vue?vue&type=script&lang=ts&"
import style0 from "./InsCmsCat12.vue?vue&type=style&index=0&id=74b19bb1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b19bb1",
  null
  
)

export default component.exports